import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useAppMediaQuery = () => {
  const theme = useTheme();
  const isXsUp = useMediaQuery(theme.breakpoints.up('xs'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isLgmDown = useMediaQuery(theme.breakpoints.down('lgm'));
  const isLgmUp = useMediaQuery(theme.breakpoints.up('lgm'));
  const isXlDown = useMediaQuery(theme.breakpoints.down('xl'));
  const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));
  const is = (queryInput: string) => useMediaQuery(queryInput);
  return {
    isXsUp,
    isSmDown,
    isSmUp,
    isMdDown,
    isMdUp,
    isLgDown,
    isLgUp,
    isLgmDown,
    isLgmUp,
    isXlDown,
    isXlUp,
    is,
  };
};
